__turbopack_context__.v({
  "header": "p_2rFq_header",
  "message": "p_2rFq_message",
  "shimmer": "p_2rFq_shimmer",
  "subtitle": "p_2rFq_subtitle",
  "text-bar-sweep": "p_2rFq_text-bar-sweep",
  "title": "p_2rFq_title",
});
